<template>
  <div class="d-flex flex-row align-center">
    <div
      :class="
        typeof $attrs.light !== undefined ? 'loader light' : 'loader dark'
      "
      :style="spinnerStyle"
    ></div>
    <div :class="slotClass"><slot /></div>
  </div>
</template>

<script>
export default {
  props: {
    spinnerStyle: { default: "" },
    slotClass: { default: "ml-2" },
  },
};
</script>

<style scoped>
.loader {
  font-size: 10px;
  margin: auto;
  text-indent: -9999em;
  width: 15px;
  height: 15px;
  border-radius: 50%;
  position: relative;
  -webkit-animation: loading 1.4s infinite linear;
  animation: loading 1.4s infinite linear;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
}
.dark {
  background: #fcaf17;
  background: -moz-linear-gradient(
    left,
    #fcaf17 10%,
    rgba(255, 255, 255, 0) 42%
  );
  background: -webkit-linear-gradient(
    left,
    #fcaf17 10%,
    rgba(255, 255, 255, 0) 42%
  );
  background: -o-linear-gradient(left, #fcaf17 10%, rgba(255, 255, 255, 0) 42%);
  background: -ms-linear-gradient(
    left,
    #fcaf17 10%,
    rgba(255, 255, 255, 0) 42%
  );
  background: linear-gradient(
    to right,
    #fcaf17 10%,
    rgba(255, 255, 255, 0) 42%
  );
}
.light {
  background: #006ae3;
  background: -moz-linear-gradient(left, #006ae3 10%, rgba(0, 0, 0, 0) 42%);
  background: -webkit-linear-gradient(left, #006ae3 10%, rgba(0, 0, 0, 0) 42%);
  background: -o-linear-gradient(left, #006ae3 10%, rgba(0, 0, 0, 0) 42%);
  background: -ms-linear-gradient(left, #006ae3 10%, rgba(0, 0, 0, 0) 42%);
  background: linear-gradient(to right, #006ae3 10%, rgba(0, 0, 0, 0) 42%);
}
.loader:before {
  width: 50%;
  height: 50%;
  border-radius: 100% 0 0 0;
  position: absolute;
  top: 0;
  left: 0;
  content: "";
}
.dark:before {
  background: #fcaf17;
}
.light:before {
  background: #006ae3;
}
.loader:after {
  width: 75%;
  height: 75%;
  border-radius: 50%;
  content: "";
  margin: auto;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}
.dark:after {
  background: #1d1c1d;
}
.light:after {
  background: white;
}
@-webkit-keyframes loading {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes loading {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
</style>
